<template>
  <div class="shop-management">
    <!-- 搜索和添加区域 -->
    <div class="header"
         style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
      <div class="search-container" style="display: flex; gap: 10px;">
        <el-input
            v-model="searchForm.name"
            placeholder="请输入店铺名称"
            clearable
            style="width: 200px;"
        ></el-input>
        <el-input
            v-model="searchForm.organizationId"
            placeholder="请输入组织ID"
            clearable
            style="width: 180px;"
            type="number"
        ></el-input>
        <el-button type="primary" @click="handleSearch">
          <i class="el-icon-search"></i> 搜索
        </el-button>
        <el-button @click="handleReset">
          <i class="el-icon-refresh"></i> 重置
        </el-button>
      </div>
      <el-button type="primary" @click="handleAddShop">
        <i class="el-icon-plus"></i> 添加店铺
      </el-button>
    </div>

    <!-- 店铺列表 -->
    <el-table
        :data="shopList"
        border
        style="width: 100%"
        v-loading="loading"
        element-loading-text="正在加载..."
    >
      <el-table-column prop="name" label="店铺名称" width="180"></el-table-column>
      <el-table-column prop="address" label="店铺地址"></el-table-column>
      <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
      <el-table-column prop="status" label="营业状态" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '营业中' : '暂停营业'}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="handleSettings(scope.row)">设置</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页控件 -->
    <div class="pagination" style="margin-top: 15px; text-align: right;">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </div>

    <!-- 店铺设置抽屉 -->
    <el-drawer
        :title="`${currentShop.name || ''} - 店铺设置`"
        :visible.sync="drawerVisible"
        direction="rtl"
        size="70%"
        :before-close="handleDrawerClose"
    >
      <div class="drawer-content">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="预约设置" name="appointmentSettings">
            <AppointmentSettings
                :shop="currentShop"
                @save="handleSaveAppointmentSettings"
            />
          </el-tab-pane>
          <el-tab-pane label="基本信息" name="basicInfo">
            <BasicInfoSettings
                :shop="currentShop"
                @save="handleSaveBasicInfo"
            />
          </el-tab-pane>
          <el-tab-pane label="服务设置" name="serviceSettings">
            <ServiceSettings
                :shop="currentShop"
                @save="handleSaveServiceSettings"
            />
          </el-tab-pane>
          <el-tab-pane label="图片管理" name="imageManagement">
            <ImageManagement
                :shop="currentShop"
                @save="handleSaveImageSettings"
            />
          </el-tab-pane>
          <el-tab-pane label="会员卡设置" name="membershipSettings">
            <MembershipSettings
                :shop="currentShop"
                @save="handleSaveMembershipSettings"
            />
          </el-tab-pane>
          <el-tab-pane label="充值设置" name="rechargeSettings">
            <RechargeSettings
                :shop="currentShop"
                @save="handleSaveRechargeSettings"
            />
          </el-tab-pane>
          <el-tab-pane label="积分设置" name="pointsSettings">
            <PointsSettings
                :shop="currentShop"
                @save="handleSavePointsSettings"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <!-- 添加/编辑店铺对话框 -->
    <el-dialog
        :title="isEdit ? '编辑店铺' : '添加店铺'"
        :visible.sync="dialogVisible"
        width="50%"
        :close-on-click-modal="false"
    >
      <el-form :model="shopForm" :rules="shopRules" ref="shopForm" label-width="100px">
        <el-form-item label="店铺名称" prop="name">
          <el-input v-model="shopForm.name"></el-input>
        </el-form-item>
        <el-form-item label="店铺地址" prop="address">
          <el-input v-model="shopForm.address"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="shopForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="营业状态" prop="status">
          <el-select v-model="shopForm.status" placeholder="请选择">
            <!-- 将值从字符串改为整数 -->
            <el-option label="营业中" value="1"></el-option>
            <el-option label="暂停营业" value="0"></el-option>
          </el-select>
        </el-form-item>
        <!-- 组织ID字段保持注释状态 -->
        <!-- <el-form-item label="组织ID" prop="organizationId">
          <el-input v-model="shopForm.organizationId" type="number"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitShopForm" :loading="submitLoading">确 定</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
import AppointmentSettings from '@/components/shop/AppointmentSettings.vue'
import BasicInfoSettings from '@/components/shop/BasicInfoSettings.vue'
import ServiceSettings from '@/components/shop/ServiceSettings.vue'
import ImageManagement from '@/components/shop/ImageManagement.vue'
import MembershipSettings from '@/components/shop/MembershipSettings.vue'
import RechargeSettings from '@/components/shop/RechargeSettings.vue'
import PointsSettings from '@/components/shop/PointsSettings.vue'
import axios from 'axios' // 假设已全局配置axios

export default {
  name: 'ShopManagement',
  components: {
    AppointmentSettings,
    BasicInfoSettings,
    ServiceSettings,
    ImageManagement,
    MembershipSettings,
    RechargeSettings,
    PointsSettings
  },
  data() {
    return {
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      submitLoading: false,

      // 搜索条件
      searchForm: {
        name: '',
        organizationId: null
      },

      shopList: [],
      currentShop: {},
      drawerVisible: false,
      dialogVisible: false,
      isEdit: false,
      activeTab: 'basicInfo',

      // 表单数据和验证规则
      shopForm: {
        name: '',
        address: '',
        phone: '',
        status: 1,
        organizationId: null
      },
      shopRules: {
        name: [
          {required: true, message: '请输入店铺名称', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入店铺地址', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        // organizationId: [
        //   {type: 'number', message: '请输入有效的组织ID', trigger: 'blur'}
        // ]
      }
    }
  },
  created() {
    // 页面加载时获取店铺列表
    this.fetchShopList()
  },
  methods: {
    // 获取店铺列表
    async fetchShopList() {
      this.loading = true
      try {
        const res = await this.$api.shop.getPage({
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          name: this.searchForm.name || undefined,
          organizationId: this.searchForm.organizationId || undefined
        })

        if (res.statusCode === 100200) {
          this.shopList = res.data.list || []
          this.total = res.data.total || 0
        } else {
          this.$message.error('获取店铺列表失败: ' + (res.data?.msg || '未知错误'))
        }
      } catch (error) {
        console.error('获取店铺列表异常:', error)
        // 根据之前的拦截器配置，error 应该是一个包含 message 的对象
        this.$message.error(error.message || '网络异常，获取店铺列表失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1 // 重置到第一页
      this.fetchShopList()
    },

    // 重置搜索条件
    handleReset() {
      this.searchForm = {
        name: '',
        organizationId: null
      }
      this.currentPage = 1
      this.fetchShopList()
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchShopList()
    },

    // 当前页码变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchShopList()
    },

    // 添加店铺
    handleAddShop() {
      this.isEdit = false
      this.shopForm = {
        name: '',
        address: '',
        phone: '',
        status: '1',
        organizationId: null
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.shopForm.clearValidate()
      })
    },

    // 编辑店铺
    handleEdit(shop) {
      this.isEdit = true
      this.shopForm = JSON.parse(JSON.stringify(shop))
      this.dialogVisible = true
    },

    // 店铺设置
    handleSettings(shop) {
      this.currentShop = JSON.parse(JSON.stringify(shop))
      this.drawerVisible = true
    },

    // 删除店铺
    handleDelete(shop) {
      this.$confirm(`确定要删除店铺 "${shop.name}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          this.loading = true
          const response = await axios.delete(`/api/shop/${shop.id}`)

          if (response.data.code === 100200) {
            this.$message.success('删除成功')
            this.fetchShopList() // 重新加载列表
          } else {
            this.$message.error('删除失败: ' + (response.data.msg || '未知错误'))
          }
        } catch (error) {
          console.error('删除店铺异常:', error)
          this.$message.error('网络异常，删除店铺失败')
        } finally {
          this.loading = false
        }
      }).catch(() => {
        // 取消删除
      })
    },

    // 提交店铺表单（新增或编辑）
    async submitShopForm() {
      this.$refs.shopForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let response
            if (this.isEdit) {
              // 编辑店铺 - 假设后端有对应的PUT接口
              response = await axios.put('/api/shop', this.shopForm)
            } else {
              // 新增店铺 - 调用提供的createShop接口
              response = await this.$api.shop.createShop(this.shopForm)
            }

            if (response.statusCode === 100200) {
              this.$message.success(this.isEdit ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.fetchShopList();
            } else {
              this.$message.error((this.isEdit ? '更新' : '添加') + '失败: ' + (response.data.msg || '未知错误'))
            }
          } catch (error) {
            console.error((this.isEdit ? '更新' : '添加') + '店铺异常:', error)
            this.$message.error(error.message || '网络异常，获取店铺列表失败')
            this.$message.error('网络异常，' + (this.isEdit ? '更新' : '添加') + '店铺失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },

    // 关闭抽屉确认
    handleDrawerClose(done) {
      this.$confirm('确定要关闭吗？未保存的更改将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => {
        // 取消关闭
      })
    },

    // 保存各类设置的方法
    async handleSaveBusinessHours(updatedHours) {
      try {
        const response = await axios.put(`/api/shop/${this.currentShop.id}/business-hours`, updatedHours)
        if (response.data.code === 100200) {
          const index = this.shopList.findIndex(item => item.id === this.currentShop.id)
          if (index !== -1) {
            this.shopList[index].businessHours = updatedHours
          }
          this.$message.success('营业时间设置已保存')
        } else {
          this.$message.error('保存失败: ' + (response.data.msg || '未知错误'))
        }
      } catch (error) {
        console.error('保存营业时间异常:', error)
        this.$message.error('网络异常，保存失败')
      }
    },

    async handleSaveAppointmentSettings(settings) {
      try {
        const response = await axios.put(`/api/shop/${this.currentShop.id}/appointment-settings`, settings)
        if (response.data.code === 100200) {
          const index = this.shopList.findIndex(item => item.id === this.currentShop.id)
          if (index !== -1) {
            this.shopList[index].appointmentSettings = settings
          }
          this.$message.success('预约设置已保存')
        } else {
          this.$message.error('保存失败: ' + (response.data.msg || '未知错误'))
        }
      } catch (error) {
        console.error('保存预约设置异常:', error)
        this.$message.error('网络异常，保存失败')
      }
    },

    // 其他设置保存方法类似，省略...
    handleSaveBasicInfo(info) {
      const index = this.shopList.findIndex(item => item.id === this.currentShop.id)
      if (index !== -1) {
        this.shopList[index].basicInfo = info
        this.$message.success('基本信息已保存')
      }
    },
    handleSaveServiceSettings(services) {
      const index = this.shopList.findIndex(item => item.id === this.currentShop.id)
      if (index !== -1) {
        this.shopList[index].services = services
        this.$message.success('服务设置已保存')
      }
    },
    handleSaveImageSettings(images) {
      const index = this.shopList.findIndex(item => item.id === this.currentShop.id)
      if (index !== -1) {
        this.shopList[index].images = images
        this.$message.success('图片设置已保存')
      }
    },
    handleSaveMembershipSettings(settings) {
      const index = this.shopList.findIndex(item => item.id === this.currentShop.id)
      if (index !== -1) {
        this.shopList[index].membershipSettings = settings
        this.$message.success('会员卡设置已保存')
      }
    },
    handleSaveRechargeSettings(settings) {
      const index = this.shopList.findIndex(item => item.id === this.currentShop.id)
      if (index !== -1) {
        this.shopList[index].rechargeSettings = settings
        this.$message.success('充值设置已保存')
      }
    },
    handleSavePointsSettings(settings) {
      const index = this.shopList.findIndex(item => item.id === this.currentShop.id)
      if (index !== -1) {
        this.shopList[index].pointsSettings = settings
        this.$message.success('积分设置已保存')
      }
    },
  }
}
</script>

<style scoped>
.shop-management {
  margin-top: 20px;
  padding: 20px 20px 0 20px;
  min-height: calc(100vh - 165px);
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.drawer-content {
  padding: 20px;
}

.el-table {
  margin-top: 10px;
}

.el-tag {
  margin-right: 10px;
}
</style>
